// Module
var code = "<h1 id=section-区块>Section 区块</h1> <p>页面内容分块。</p> <p>可承载文字、列表、图片、段落，常用于后台概览页面。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>...。</li> </ul> ";
// Exports
module.exports = code;